import { useState } from 'react';
import { CirleDownAngleIcon, HeaderDropdownMenu } from '@components';
import { categoryPath } from '@paths';
import { addTrailingSlash } from '@utils';

export interface HeaderCategoryMenuCategory {
  name?: string | null;
  slug?: string | null;
  uri?: string | null;
}

export type HeaderCategoryMenuCategories = (
  | HeaderCategoryMenuCategory
  | null
  | undefined
)[];

const SpMenu: React.FC<{
  categories?: HeaderCategoryMenuCategories;
}> = ({ categories }) => (
  <div>
    {categories?.map((cat) => (
      <a
        href={addTrailingSlash(categoryPath(cat?.slug))}
        key={cat?.slug}
        className='block py-1 text-right font-normal'
      >
        {cat?.name}
      </a>
    ))}
  </div>
);

export const HeaderCategoryMenu: React.FC<{
  categories?: HeaderCategoryMenuCategories;
}> = ({ categories }) => {
  const [open, setOpen] = useState(false);

  if (!categories?.length) {
    return null;
  }

  return (
    <div className='w-full lg:w-auto'>
      <div
        className='relative cursor-pointer transition-opacity hover:opacity-80'
        onClick={() => {
          setOpen((prev) => !prev);
        }}
      >
        <span className='flex items-center justify-end font-bold'>
          カテゴリから探す
          <span className='px-1'>
            <CirleDownAngleIcon className={`w-5 ${open ? 'rotate-180' : ''}`} />
          </span>
        </span>
      </div>
      <div className='relative' hidden={!open}>
        <div className='hidden lg:block'>
          <HeaderDropdownMenu
            items={categories.map((category) => ({
              label: category?.name || '',
              href: categoryPath(category?.slug),
            }))}
          />
        </div>
        <div className='lg:hidden'>
          <SpMenu categories={categories} />
        </div>
      </div>
    </div>
  );
};
